// extracted by mini-css-extract-plugin
export default {"createBtnWrap":"LibraryTab_createBtnWrap__GK-o5","plusIcon":"LibraryTab_plusIcon__FGtRa"};